import React, { useState } from 'react';
import { TextField, Button, Container, Typography, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import img from '../assets/banner.jpg';
import logo from '../assets/LWPL_White_Logo.png';
import { register } from '../api';
import { yellow } from '@mui/material/colors';

function Register() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      // Removed entity_id
      const res = await register({ email, password, username });
      console.log('Register Response:', res);
      if (res.id) {
        localStorage.setItem('email', email);
        setSuccess('Registration successful! Please check your email to verify your account, then proceed to login.');
        setEmail('');
        setPassword('');
        setUsername('');
      } else {
        setError(res.error || 'Registration failed');
      }
    } catch (err) {
      console.error('Registration error:', err);
      setError(`Registration error: ${err.error || err.message}`);
    }
  };

  const handleLoginRedirect = (e) => {
    e.preventDefault();
    navigate('/');
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Container maxWidth="sm" style={{ marginTop: '10%' }}>
        <Box display="flex" justifyContent="center" mb={8}>
          <img src={logo} alt="Logo" style={{ height: 150 }} />
        </Box>
        <Typography variant="h4" gutterBottom align="center">Register</Typography>
        <form onSubmit={handleRegister}>
                <TextField
        label="Username"
        fullWidth
        margin="normal"
        required
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        sx={{
          '& input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px #121212 inset', // Matches portal's dark background
            WebkitTextFillColor: '#fff', // Ensures text remains white
            backgroundColor: '#121212', // Dark background for autofill
          },
          '& input:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0 1000px #121212 inset, 0 0 0 2px #e0b256', // Highlight with theme color on focus
            WebkitTextFillColor: '#fff',
          },
          '& .MuiInputBase-root': {
            backgroundColor: '#1e1e1e', // Consistent with form input background
            color: '#fff',
          },
          '& .MuiInputLabel-root': {
            color: '#ccc', // Label color to match sidebar
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#e0b256', // Theme color on focus
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#ccc',
            },
            '&:hover fieldset': {
              borderColor: '#e0b256', // Theme color on hover
            },
            '&.Mui-focused fieldset': {
              borderColor: '#e0b256', // Theme color on focus
            },
          },
        }}
      />
      <TextField
        label="Email"
        fullWidth
        margin="normal"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        sx={{
          '& input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px #121212 inset', // Matches portal's dark background
            WebkitTextFillColor: '#fff', // Ensures text remains white
            backgroundColor: '#121212', // Dark background for autofill
          },
          '& input:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0 1000px #121212 inset, 0 0 0 2px #e0b256', // Highlight with theme color on focus
            WebkitTextFillColor: '#fff',
          },
          '& .MuiInputBase-root': {
            backgroundColor: '#1e1e1e', // Consistent with form input background
            color: '#fff',
          },
          '& .MuiInputLabel-root': {
            color: '#ccc', // Label color to match sidebar
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#e0b256', // Theme color on focus
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#ccc',
            },
            '&:hover fieldset': {
              borderColor: '#e0b256', // Theme color on hover
            },
            '&.Mui-focused fieldset': {
              borderColor: '#e0b256', // Theme color on focus
            },
          },
        }}
      />
      <TextField
        label="Password"
        type="password"
        fullWidth
        margin="normal"
        required
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        sx={{
          '& input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px #121212 inset', // Matches portal's dark background
            WebkitTextFillColor: '#fff', // Ensures text remains white
            backgroundColor: '#121212', // Dark background for autofill
          },
          '& input:-webkit-autofill:focus': {
            WebkitBoxShadow: '0 0 0 1000px #121212 inset, 0 0 0 2px #e0b256', // Highlight with theme color on focus
            WebkitTextFillColor: '#fff',
          },
          '& .MuiInputBase-root': {
            backgroundColor: '#1e1e1e', // Consistent with form input background
            color: '#fff',
          },
          '& .MuiInputLabel-root': {
            color: '#ccc', // Label color to match sidebar
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#e0b256', // Theme color on focus
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#ccc',
            },
            '&:hover fieldset': {
              borderColor: '#e0b256', // Theme color on hover
            },
            '&.Mui-focused fieldset': {
              borderColor: '#e0b256', // Theme color on focus
            },
          },
        }}
      />
          <Button
  variant="contained"
  type="submit"
  fullWidth
  sx={{
    mt: 2,
    backgroundColor: '#e0b256',
    '&:hover': {
      backgroundColor: '#c7993d', // Slightly darker shade for hover effect
    },
    '&:disabled': {
      backgroundColor: '#e0b25666', // Semi-transparent for disabled state
    },
  }}
>
  Register
</Button>
          {error && (
            <Typography color="error" align="center" sx={{ mt: 2 }}>
              {error}
            </Typography>
          )}
          {success && (
            <Typography color="success.main" align="center" sx={{ mt: 2 }}>
              {success}
            </Typography>
          )}
        </form>
        <Typography align="center" sx={{ mt: 2 }}>
          Already have an account?{' '}
            <Typography
      component="span"
      sx={{
        cursor: 'pointer',
        textDecoration: 'underline',
        color: '#e0b256', // Theme color
        '&:hover': {
          color: '#c7993d', // Slightly darker shade for hover effect
        },
      }}
      onClick={handleLoginRedirect}
    >
      Login here
    </Typography>
        </Typography>
      </Container>
    </Box>
  );
}

export default Register;
